import { Button, Spinner } from '@heroui/react';
import _ from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

export function SurveyLoader({ handleBack, text, type }) {
  const navigate = useNavigate();
  const { t } = useTranslation('survey');

  if (type && type === 'error') {
    return (
      <div className="flex flex-row h-[100dvh] justify-center p-4">
        <div className="flex flex-col justify-center">
          <h1 className="text-xl">{t('common.text.error')}</h1>
          <div className="py-12 text-left mx-auto whitespace-pre-line">
            {!_.isEmpty(text) ? (
              <p>{text}</p>
            ) : (
              <p>{t('surveyloader.error.description')}</p>
            )}
          </div>
          <div className="flex flex-row gap-4 justify-center">
            {handleBack && (
              <Button
                className="w-1/4"
                color="primary"
                onPress={() => handleBack()}
              >
                {t('common.action.back')}
              </Button>
            )}
            <Button
              className="w-1/4"
              color="danger"
              onPress={() => navigate('/')}
              variant="bordered"
            >
              {t('common.action.exit_session')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-row h-[100dvh] justify-center">
      <div className="flex flex-col justify-center ">
        <Spinner className="m-4" color="primary" size="lg" />
        <h1 className="text-lg">
          {t('common.text.loading')} {text}
        </h1>
      </div>
    </div>
  );
}
